module.exports = __webpack_public_path__ + "img/icon-cashless-usa.b22d3a4b.svg";